export const OrganisationTypeSelect2MultipleTypeOption = {
    placeholder: "<Type>",
    allowClear: false,
    multiple:"multiple",
    theme: "select2-builder-multiple-gray",
    width :'auto',
    dropdownAutoWidth : true,
    ajax: null
}